<template>
  <div class="loading-dots" :aria-label="ariaLabel" role="status">
    <span v-if="text" class="loading-text">{{ text }}</span>
    <span class="dot" v-for="n in 3" :key="n" />
  </div>
</template>

<script>
export default {
  name: 'LoadingDots',
  props: {
    text:    { type: String, default: 'Cargando' },
    ariaLabel: { type: String, default: 'Cargando' }
  }
}
</script>

<style scoped>
.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-family: inherit;
}

/* Texto opcional */
.loading-text {
  font-size: 0.875rem;
  color: rgba(110, 107, 123, 0.75);
  font-size: 1rem;
  font-weight: 400;
  font-family: inherit;
}

/* Puntos */
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgba(110, 107, 123, 0.75);
  /* Cada punto comienza la animación con retraso */
  animation: blink 1.2s infinite ease-in-out both;
}

.dot:nth-child(2) { animation-delay: 0.2s; }
.dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes blink {
  0%, 80%, 100% { opacity: 0.25; }
  40%          { opacity: 1; }
}
</style>